
function gtag(...args: any) {
  window.dataLayer!.push(args)
}

export {
  gtag,
}
